export const CARD_DIGITS_LENGTH = 16;

export function normalizeCardDigits(value) {
  return String(value || '').replace(/\D/g, '');
}

/** Форматирует ввод номера карты: только цифры, максимум 16, группы по 4. */
export function formatCardNumberInput(value) {
  const digits = normalizeCardDigits(value).slice(0, CARD_DIGITS_LENGTH);
  return digits.replace(/(.{4})/g, '$1 ').trim();
}

export function isValidCardNumber(value) {
  return normalizeCardDigits(value).length === CARD_DIGITS_LENGTH;
}
